import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NbCardModule, NbIconModule, NbSpinnerModule } from '@nebular/theme';
import { finalize } from 'rxjs/operators';
import { UsuarioResposta } from '../../core/api/usuario';
import { AuthService } from '../../core/auth/auth.service';
import { mensagemDeErro } from '../../utils/mensagem-erro';

/**
 * Os dados da própria conta, em leitura.
 *
 * Fonte: `GET /autenticacao/usuario-logado`, relido ao abrir — o que está em memória veio do
 * login e pode estar velho se alguém da coordenação mexeu no cadastro depois.
 *
 * **Não edita.** O contrato só oferece `PUT /usuarios/{id}`, que é substituição do registro
 * inteiro, inclusive dos perfis de acesso: um "salvar" aqui revogaria acesso sem querer. Se a
 * edição do próprio cadastro for pedida, ela precisa de endpoint próprio (`CTR-10`).
 */
@Component({
  selector: 'app-meus-dados',
  standalone: true,
  imports: [CommonModule, NbCardModule, NbIconModule, NbSpinnerModule],
  templateUrl: './meus-dados.component.html',
  styleUrl: './meus-dados.component.scss',
})
export class MeusDadosComponent implements OnInit {
  usuario: UsuarioResposta | null = null;
  carregando = false;
  erro: string | null = null;

  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    this.usuario = this.auth.getPerfil();
    this.carregando = true;
    this.auth
      .reloadPerfil()
      .pipe(finalize(() => (this.carregando = false)))
      .subscribe({
        next: (u) => {
          if (u) this.usuario = u;
          else if (!this.usuario) this.erro = 'Não foi possível carregar seus dados.';
        },
        error: (err) => (this.erro = mensagemDeErro(err, 'Não foi possível carregar seus dados.')),
      });
  }

  /** `TAB-13` — campo sem valor aparece com travessão, não em branco. */
  ou(valor: string | null | undefined): string {
    const v = (valor ?? '').trim();
    return v || '—';
  }

  get cpfFormatado(): string {
    const d = (this.usuario?.cpf ?? '').replace(/\D/g, '');
    if (d.length !== 11) return this.ou(this.usuario?.cpf);
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  }

  get perfis(): string[] {
    const u = this.usuario;
    if (!u) return [];
    const nomes: string[] = [];
    if (u.admin) nomes.push('Administração');
    if (u.coordenacao) nomes.push('Coordenação');
    if (u.catequista) nomes.push('Catequista');
    return nomes;
  }
}
